// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  position: fixed;
  inset: 0;
  background-color: rgba(7, 30, 92, 0.301);
  z-index: 30;
}

.loader-container div {
  position: relative;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  z-index: 40;
}

.loader-container p {
  text-align: center;
  color: black;
  font-size: 22px;
}

.lds-hourglass {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-hourglass:after {
  content: " ";
  display: block;
  border-radius: 50%;
  width: 0;
  height: 0;
  margin: 8px;
  box-sizing: border-box;
  border: 32px solid #231c42;
  border-color: #231c42 transparent #231c42 transparent;
  animation: lds-hourglass 1.2s infinite;
}
@keyframes lds-hourglass {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  100% {
    transform: rotate(1800deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/loader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,qDAAqD;EACrD,sCAAsC;AACxC;AACA;EACE;IACE,oBAAoB;IACpB,iEAAiE;EACnE;EACA;IACE,yBAAyB;IACzB,8DAA8D;EAChE;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".loader-container {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(7, 30, 92, 0.301);\n  z-index: 30;\n}\n\n.loader-container div {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  translate: -50% -50%;\n  z-index: 40;\n}\n\n.loader-container p {\n  text-align: center;\n  color: black;\n  font-size: 22px;\n}\n\n.lds-hourglass {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n}\n\n.lds-hourglass:after {\n  content: \" \";\n  display: block;\n  border-radius: 50%;\n  width: 0;\n  height: 0;\n  margin: 8px;\n  box-sizing: border-box;\n  border: 32px solid #231c42;\n  border-color: #231c42 transparent #231c42 transparent;\n  animation: lds-hourglass 1.2s infinite;\n}\n@keyframes lds-hourglass {\n  0% {\n    transform: rotate(0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  50% {\n    transform: rotate(900deg);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  100% {\n    transform: rotate(1800deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
